module.exports = __webpack_public_path__ + "img/fonda-lee.ee50b754.png";